export const MCP_PRODUCT_NAME = 'MCP';
export const MCP_PRODUCT_NAME_PLURAL = 'MCPs';
